import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { OtpComponent } from './otp/otp.component';
import { ResetPasswordComponent } from './resetpassword/resetpassword.component';
import { SignUpComponent } from './signup/signup.component';

import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { MessageModule } from '@syncfusion/ej2-angular-notifications';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ResetpasswordFormComponent } from './resetpassword-form/resetpassword-form.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { LoadingAnimationModule } from "../../core/loading-animation/loading-animation.module";


@NgModule({
    declarations: [
        LoginComponent,
        ResetPasswordComponent,
        SignUpComponent,
        OtpComponent,
        ResetpasswordFormComponent,
        LoginFormComponent,
    ],
    exports: [
        LoginComponent,
        SignUpComponent,
        ResetPasswordComponent,
    ],
    imports: [
    CommonModule,
    LoginRoutingModule,
    ButtonModule,
    FormsModule,
    CheckBoxModule,
    ReactiveFormsModule,
    MessageModule,
    DropDownListModule,
    DialogModule,
    MaskedTextBoxModule,
    LoadingAnimationModule
],

})
export class LoginModule { }
